// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from 'firebase'
import {get_list_info} from '@/util/mylist_util.js'

// Add the Firebase products that you want to use
import "firebase/auth"
import "firebase/firestore"
import "firebase/analytics"
import "firebase/storage"
import store from "./store"

import axios from 'axios'

const firebaseConfig = {
  apiKey: "AIzaSyAASJEBUfLvuNgiLn5Qk-8b2LNEwnHkNaY",
  authDomain: "twistock.firebaseapp.com",
  databaseURL: "https://twistock.firebaseio.com",
  projectId: "twistock",
  storageBucket: "twistock.appspot.com",
  messagingSenderId: "99223105259",
  appId: "1:99223105259:web:9fcd5f1be586b37ab658ae",
  measurementId: "G-369RF0P6PP"
}

export default {
  init() {
    firebase.initializeApp(firebaseConfig)
    firebase.analytics()
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  },
  async login() {
    const provider = new firebase.auth.TwitterAuthProvider()
    try {
      const result = await firebase.auth().signInWithPopup(provider)
      // This gives you a the Twitter OAuth 1.0 Access Token and Secret.
      // You can use these server side with your app's credentials to access the Twitter API.
      const token = result.credential.accessToken
      const secret = result.credential.secret
      // twitter user info
      const user_id = result.additionalUserInfo.username
      const user_name = result.user.displayName
      const user_icon_url = result.user.photoURL
      // firestoreにユーザーの情報を登録
      const db = firebase.firestore()
      const user_db = db.collection("users").doc(result.user.uid)
      try {
        await user_db.set({
          twitter_id: user_id,
          twitter_name: user_name,
          icon_url: user_icon_url,
          token: token,
          token_secret: secret,
        }, {merge: true})
      } catch (e) {
        console.error("Error writing document: ", e)
      }
    } catch (err) {
      console.error(err.code, err.message)
    }
  },
  logout() {
    firebase.auth().signOut()
  },
  onAuth() {
    firebase.auth().onAuthStateChanged(
      async (currentUser) => {
        if(currentUser == null){
          store.commit("setUser", null)
          return
        }
        // ユーザーの情報を取得してvuexにcommitする
        const db = firebase.firestore()
        const user_db = db.collection("users").doc(currentUser.uid)
        const doc = await user_db.get()
        if(doc.exists == false) return
        let user_info = doc.data()
        user_info.uid = currentUser.uid
        store.commit("setUser", user_info)
        // リストの情報を取得してvueにcommitする
        store.commit("resetListInfo")
        const create_lists = store.getters.getCreateLists
        create_lists.forEach(async (elm) => {
          const list_info = await get_list_info(elm.list_id)
          store.commit("updateListInfo", {list_name:list_info.list_name , listed_tweets:list_info.tweets})
        })
      }
    )
  },
  async getRankingDataFromStorage(day_str="20200209") {
    const storageRef = firebase.storage().ref(`twitter_daily_ranking/ranking_tweets_${day_str}.json`)
    const url = await storageRef.getDownloadURL()
    const res = await axios.get(url)
    const ranking_tweets = res.data
    console.log("ranking data", day_str, ranking_tweets)
    const valided_tweets = ranking_tweets.map((tweet) => {
      if("movie" in tweet){
        tweet.image = [String(tweet.movie.thumbnail)]
        tweet.movie = [String(tweet.movie.video_url)]
      }
      return tweet
    })
    return valided_tweets
  },
  async getRandomRankingDataFromStorage() {
    const storageRef = firebase.storage().ref(`twitter_daily_ranking/ranking_tweets_random.json`)
    const url = await storageRef.getDownloadURL()
    const res = await axios.get(url)
    const ranking_tweets = res.data
    const valided_tweets = ranking_tweets.map((tweet) => {
      if("movie" in tweet){
        tweet.image = [String(tweet.movie.thumbnail)]
        tweet.movie = [String(tweet.movie.video_url)]
      }
      return tweet
    })
    return valided_tweets
  }
}